export const blockIconsSocialPersonAddNew = (
	<span className='material-symbols-outlined'>person_add</span>
);
